import React, { useEffect, useState } from 'react';
import { useCalendarPreferences } from '../../hooks/useCalendarPreferences';

/**
 * Component that displays a minimalist date and time
 */
const UserGreeting: React.FC = () => {
  const [dateTime, setDateTime] = useState('');
  const { locale } = useCalendarPreferences();

  useEffect(() => {
    // Function to update the date and time
    const updateDateTime = () => {
      const now = new Date();

      // Format the date (e.g., "Fri, October 2nd")
      const formattedDate = now.toLocaleDateString(locale, {
        weekday: 'short', // Use abbreviated weekday names (Mon, Tue, Wed, etc.)
        month: 'long',
        day: 'numeric',
      });

      // Add ordinal suffix to day
      const day = now.getDate();
      let daySuffix = 'th';
      if (day % 10 === 1 && day !== 11) daySuffix = 'st';
      if (day % 10 === 2 && day !== 12) daySuffix = 'nd';
      if (day % 10 === 3 && day !== 13) daySuffix = 'rd';

      // Format time based on user's locale
      const formattedTime = now.toLocaleTimeString(locale, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: undefined, // Let browser decide based on locale
      });

      // Convert AM/PM to lowercase if present
      const lowerCaseTime = formattedTime.replace(/AM|PM/g, match => match.toLowerCase());

      // Replace the day number with day+suffix in the formatted date
      const dateWithSuffix = formattedDate.replace(/\b\d+\b/, day + daySuffix);

      // Set the date and time display with bullet instead of comma
      setDateTime(`${dateWithSuffix} • ${lowerCaseTime}`);
    };

    // Update initially
    updateDateTime();

    // Update every minute
    const intervalId = setInterval(updateDateTime, 60000);

    // Clean up interval
    return () => clearInterval(intervalId);
  }, [locale]);

  return <h1 className="text-2xl font-bold text-gray-800">{dateTime}</h1>;
};

export default UserGreeting;
